/**
 * A reply's text as it is said aloud. A voice turn asks the model for plain
 * spoken sentences, and this catches what gets through anyway: Markdown
 * marks, links, code and emoji, none of which a voice should read out.
 */

const EMOJI = /\p{Extended_Pictographic}(️|‍\p{Extended_Pictographic})*/gu;

export function toSpeech(text: string): string {
  return (
    text
      // Code is shown, never read.
      .replace(/```[\s\S]*?(```|$)/g, ' ')
      .replace(/`([^`]*)`/g, '$1')
      // A link is its words; a bare address is not worth saying.
      .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
      .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
      .replace(/<?https?:\/\/\S+>?/g, '')
      // Headings, quotes, list marks and table rules at the start of a line.
      .replace(/^\s{0,3}(#{1,6}\s+|>\s?|[-*+]\s+|\d+[.)]\s+)/gm, '')
      .replace(/^\s*\|?\s*:?-{3,}.*$/gm, '')
      .replace(/\s*\|\s*/g, ', ')
      // Emphasis.
      .replace(/(\*\*|__)(.+?)\1/g, '$2')
      .replace(/(^|[^\w*])[*_]([^*_\n]+)[*_](?=[^\w*]|$)/g, '$1$2')
      .replace(/~~(.+?)~~/g, '$1')
      .replace(EMOJI, '')
      .replace(/\s+/g, ' ')
      .replace(/\s+([,.!?;:])/g, '$1')
      .replace(/^[,\s]+/, '')
      .trim()
  );
}
